<div #videoContent class="video-content">
  <video #camera class="camera" playsinline></video>

  <div class="camera-help">
    <div class="camera-black-background"></div>
    <div class="camera-clip-hole-container">
      <div class="camera-black-background"></div>
      <div class="camera-clip-hole">

      </div>
      <div class="camera-black-background-bottom">
        <div class="camera-help-text-container">
          <p class="camera-help-title">
            {{ isValidatingPhoto ? 'Valida tu fotografía' : messageText }}
          </p>
          <p class="camera-help-description">
            {{ isValidatingPhoto ? 'Asegurate de que la imagen sea legible y que no haya reflejos' : 'Ajuste la pagina completa con su imagen en el marco; asegurese de incluir las lineas de codigo  de forma legible' }}
          </p>
        </div>
      </div>
    </div>
    <div class="camera-black-background"></div>
  </div>

  <mat-icon class="camera-icon-close" (click)="closeCamera()">close</mat-icon>

  <div class="camera-actions">
    <div #actionPhoto (click)="takePhoto()" class="camera-actions-take-photo"></div>
    <div #actionConfirm class="camera-actions-confirm-container">
      <div class="camera-actions-confirm">
        <button mat-flat-button (click)="confirmPhoto()"><mat-icon>check</mat-icon> Confirmar</button>
        <button mat-flat-button (click)="retryPhoto()" class="tertiary-button"><mat-icon>undo</mat-icon> Reintentar</button>
      </div>
    </div>
  </div>
</div>
